import React from "react";
import InterphoneListView from "./InterphoneListView";
import { UseInterphoneListProps, UseInterphoneListQueryProps } from "./type";
import { useInterphoneList } from "./useInterphoneList";
import { useInterphoneListQuery } from "./useInterphoneListQuery";

function InterphoneList() {
  const queries: UseInterphoneListQueryProps = useInterphoneListQuery();
  const hook: UseInterphoneListProps = useInterphoneList();

  return <InterphoneListView queries={queries} hook={hook} />;
}
export default React.memo(InterphoneList);
